export default "* Bast\n* Video <a href=\"https://www.blivnaturligvis.dk/askogliv2\" target=\"_blank\">www.blivnaturligvis.dk/askogliv2</a>";